import { IBalanceOfTrade } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getDataOrNil } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getDataOrNil'

import { IChangeComputedFieldsProps } from '../../../models/IChangeComputedFieldsProps'

const observedKeys = ['HPSpend', 'TotalRevenue']
// const observedFields: (keyof IAccount360DataByGBU)[] = ['PersonalSystems', 'Print', 'Supplies']
export const changeBalanceOfTrade = ({
  keyValue,
  data,
  field,
}: IChangeComputedFieldsProps<IBalanceOfTrade>) => {
  if (observedKeys.includes(keyValue)) {
    const foundBalanceIndex = data.findIndex((el) => el.Key === 'BalanceOfTrade')
    const foundHPSpend = data.findIndex((el) => el.Key === 'HPSpend')
    const foundTotalRevenueIndex = data.findIndex((el) => el.Key === 'TotalRevenue')

    if (foundBalanceIndex > -1) {
      data[foundBalanceIndex] = {
        ...data[foundBalanceIndex],
        [field]:
          getDataOrNil(data[foundTotalRevenueIndex]?.[field]) -
          getDataOrNil(data[foundHPSpend]?.[field]),
      }
    }
  }

  return data
}
